import { useEffect, useRef, useState } from "react"
import DashboardMap from "./DashboardMap";
import DashboardPendingCard from "./DashboardPendingCard";
import IncidentCountCard from "./IncidentCountCard";
import QuickAccessCard from "./QuickAccessCard";
import DashboardTemplate from "./DashboardTemplate";
import AcknowledgeCountCard from "./AcknowledgeCountCard";
import DashboardActiveWarningCard from "./DashboardActiveWarningCard";
import DashboardMapNew from "./DashboardMapNew";
import LocationMap from "../map/LocationMap";
import { AreaColors } from "../map/LocationMapTypes";

const Dashboard = () => {

    const BASE_URL = process.env.REACT_APP_BASE_URL

    const colors: AreaColors = {
        E92000001: "#3b82f6",   // England
        S92000003: "#22c55e",   // Scotland
        E09000033: "#ef4444",   // Westminster
    }

    return (
        <div className="dashboard-main">
            <div className="dashboard-wrapper">
                {/* <DashboardMapNew gridArea="map"/> */}
                <LocationMap gridArea="map" height='100%' onAreaClick={a => console.log(a.code, a.name)} showWarningIcons allowIconToggle={false}/>
                <div className="count-wrapper" style={{gridArea: 'dash-card-1'}}>
                    <DashboardPendingCard gridArea=""/>
                    <DashboardActiveWarningCard gridArea="" />
                    <IncidentCountCard gridArea=""/>
                    <AcknowledgeCountCard gridArea="" />
                </div>
                
                {/* <QuickAccessCard gridArea="dash-card-3" title="Quick Access"/> */}
                <DashboardTemplate gridArea="dash-card-2" title="Early warning templates"/>
            </div>
        </div>
        
    )
}

export default Dashboard